const VixSelectChange = function(el) {
    el = document.querySelectorAll('.evaluate .inpSel select');
    el.forEach(el => {
        el.addEventListener('change', (event) => {
            const elParent = event.currentTarget.closest('.evaluate');
            let idx = event.target.options.selectedIndex;
            let text = event.target[idx].text;
            //미분류,합격부보는 색상이 같아 default
            switch (text) {
                case '합격':
                    elParent.className = 'evaluate pass';
                    break;
                case '불합격':
                    elParent.className = 'evaluate fail';
                    break;
                default:
                    elParent.className = 'evaluate';
            }
        });
    });
};
export default VixSelectChange;
